//创建路由列表
import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import { isLogin } from "../utils/api"

import Login from "@/views/Login";
import Home from "@/views/Home";
import ErrorCounseling from "@/views/ErrorCounseling";
import SubjectHome from "@/views/SubjectHome";
import ViewStatistics from "@/views/ViewStatistics";
import ViewEnStatistics from "@/views/ViewEnStatistics";
import PurchaseRecord from "@/views/PurchaseRecord";
import ViewingHistory from "@/views/ViewingHistory";
import ChangePassword from "@/views/ChangePassword";
import Challenge from "@/views/Challenge";
import Enchallenge from "@/views/Enchallenge";
import Register from "@/views/Register";
import Publicity from "@/views/Publicity";
import ServiceAgreement from "@/views/ServiceAgreement";
import UserAgreement from "@/views/UserAgreement";
import Footer from "@/components/common/Footer";
import Header from "@/components/common/Header";
import MessageBox from "@/components/popup/MessageBox";
import Tab from "@/components/tabs/Tab";
import downTime from "@/components/downTime/downTime";
import chart from "@/components/chart/chart";
import Math from "@/views/Math";
import ErrorContent from "@/views/ErrorContent";
import ErrorContentCapter from "@/views/ErrorContentCapter";
import ErrorContentDetail from "@/views/ErrorContentDetail";
import Record from "@/views/Record";
import Practice from "@/views/Practice";
import ChineseTasks from "@/views/ChineseTasks";
import EnglishTasks from "@/views/EnglishTasks";
import OverView from "@/views/overview";
import WebRTC from '@/components/WebRTC';

import UnitManage from "@/views/sys/UnitManage";      // 合作单位管理
import StaffManage from "@/views/sys/StaffManage";     // 员工列表
import SysReport from "@/views/sys/SysReport";         // 功能报表

Vue.use(Router);
const router = new Router({
	mode: 'history',
	history: true,
	saveScrollPosition: true,
	routes: [
		//路径                      组件
		{
			path: "/",
			redirect: "login",
			meta: {
				title: "田园智城",
			}
		},
		{
			path: "/login",
			name: "login",
			component: Login,
			meta: {
				title: "田园智城",
			}
		},
		{ //注册
			path: "/register",
			name: "Register",
			component: Register,
			meta: {
				title: "注册",
			}
		},

		{
			path: "/sys",
			redirect: "/sys/unit",
			meta: {
				needSysRole: true
			}
		},
		{
			path: "/sys/unit",
			name: "UnitManage",
			component: UnitManage,
			meta: {
				title: "田园智城",
				needSysRole: true
			}
		},
		{
			path: "/sys/staff",
			name: "StaffManage",
			component: StaffManage,
			meta: {
				title: "田园智城",
				needSysRole: true
			}
		},
		{
			path: "/sys/report",
			name: "SysReport",
			component: SysReport,
			meta: {
				title: "田园智城",
				needSysRole: true
			}
		},

		{ //学习中心
			path: "/home",
			name: "Home",
			component: Home,
			meta: {
				title: "学习中心",
			}
		},
		{ //错题辅导
			path: "/errorCounseling",
			name: "ErrorCounseling",
			component: ErrorCounseling,
			meta: {
				title: "错题辅导",
			}
		},
		{ //智能英语
			path: "/subjecthome",
			name: "subjecthome",
			component: SubjectHome,
			meta: {
				title: "科目主页",
			}
		},
		{//查看统计
			path: "/viewStatistics",
			name: "ViewStatistics",
			component: ViewStatistics,
			meta: {
				title: "查看统计",
			}
		},
		{//查看英汉互译统计
			path: "/viewEnStatistics",
			name: "ViewEnStatistics",
			component: ViewEnStatistics,
			meta: {
				title: "查看英汉互译章节统计",
			}
		},
		{//购买记录
			path: "/purchaseRecord",
			name: "PurchaseRecord",
			component: PurchaseRecord,
			meta: {
				title: "购买记录",
			}
		},
		{//查看历史记录
			path: "/viewingHistory",
			name: "ViewingHistory",
			component: ViewingHistory,
			meta: {
				title: "查看历史记录",
			}
		},
		{//修改密码
			path: "/changePassword",
			name: "ChangePassword",
			component: ChangePassword,
			meta: {
				title: "修改密码",
			}
		},
		{ //题目
			path: "/Challenge",
			name: "challenge",
			component: Challenge,
			meta: {
				title: "做题",
			}
		},
		{ //英汉互译题目
			path: "/Enchallenge",
			name: "enchallenge",
			component: Enchallenge,
			meta: {
				title: "做题",
			}
		},
		{
			path: "/errorcontent",
			name: "ErrorContent",
			component: ErrorContent ,
			meta:{
				title: "错题订正"
			}
		},
		{
			path: "/errorcontentCapter",
			name: "ErrorContentCapter",
			component: ErrorContentCapter ,
			meta:{
				title: "错题巩固"
			}
		},
		{
			path: "/errorcontentdetail",
			name: "ErrorContentDetail",
			component: ErrorContentDetail ,
			meta:{
				title: "错题订正"
			}
		}, //错题内容
		{ path: "/publicity", name: "Publicity", component: Publicity }, //教研员资质公示
		{ path: "/serviceAgreement", name: "ServiceAgreement", component: ServiceAgreement }, //服务协议
		{ path: "/userAgreement", name: "UserAgreement", component: UserAgreement }, //用户协议
		{ path: "/Footer", name: "Footer", component: Footer }, //公共页脚
		{ path: "/Header", name: "Header", component: Header }, //页头
		{ path: "/MessageBox", name: "MessageBox", component: MessageBox }, //弹框
		{ path: "/Tab", name: "Tab", component: Tab }, //选项卡
		{ path: "/downTime", name: "downTime", component: downTime },
		{ path: "/chart", name: "chart", component: chart }, //折线图
		{ path: "/math", name: "Math", component: Math }, //数学
		{ path: "/record", name: "Record", component: Record }, //数据统计
		{ path: "/WebRTC", name: "WebRTC", component: WebRTC,
			meta:{
				title: "视频辅导"
			}
		},
		{ path: "/practice", name: "Practice", component: Practice },
		{ path: "/chineseTasks", name: "ChineseTasks", component: ChineseTasks },
		{ path: "/englishTasks", name: "EnglishTasks", component: EnglishTasks },
		{ path: "/overview", name: "overview", component: OverView, meta:{title:"数据概览"} },
		{ path: "*", component: () => import("@/views/error_404.vue") }
	]
});

router.beforeEach((to, from, next) => {
	// 登录页直接放行
	if (to.name === "login") {
		return next();
	}

	// 未登录一律跳登录
	if (!isLogin()) {
		return next({
			path: "/login",
			query: { redirect_uri: encodeURIComponent(to.fullPath) }
		});
	}

	const accountType = localStorage.getItem("accountType");

	if (to.meta.needSysRole) {
		if (accountType === "sys") {
			return next();
		} else {
			return next({ path: "/home" });
		}
	}

	const studentRouteNames = [
		"Home", "subjecthome", "challenge", "enchallenge",
		"Practice", "ChineseTasks", "EnglishTasks", "ErrorCounseling",
		"ErrorContent", "ErrorContentCapter", "ErrorContentDetail",
		"ViewStatistics", "ViewEnStatistics", "ViewingHistory", "Record", "Math",
		"overview"
	];
	if (accountType === "sys" && studentRouteNames.includes(to.name)) {
		return next({ path: "/sys/unit" });
	}

	next();
});

// 修改网页标题
router.afterEach((to) => {
	let title = to.meta.title || "田园智城";
	document.title = title;
});

router.onError(error => {
	console.log(error.message);
	const pattern = /Loading chunk (\d)+ failed/g;
	const isChunkLoadFailed = error.message.match(pattern);
	const targetPath = router.history.pending.fullPath;
	if (isChunkLoadFailed) {
		router.replace(targetPath);
	}
});

export default router;
